import{a as o}from"./chunk-IEE7G5JG.js";import{a as r}from"./chunk-ANXBDSUI.js";function T(...a){return o(i,a)}var i=a=>(n,t,u)=>u.findIndex(e=>a(n,e))===t?{done:!1,hasNext:!0,next:n}:r;export{T as a};
